export enum SynchronizationStatusEnum {
  COMPLETED = 'completed',
  PARTIAL = 'partial',
  FAILED = 'failed',
  NEVER = 'never',
  IN_PROGRESS = 'in_progress',
}
